import type { PageRes, PageParams } from '@/types'
import request from '@/utils/request'
import type { MailItem, MailListItem } from './type'

export function getMailListApi(params: PageParams) {
  return request<PageRes<MailListItem[]>>({
    url: 'mail/list',
    params,
  })
}

export function getMailDetailApi(params: { id: number }) {
  return request<MailItem>({
    url: 'mail/detail',
    params,
  })
}
